import React from 'react'
import './Gaze.scss'
// import { ReactDOM  } from 'react';
const Gaze=()=> {
    
   
  

        
    return (
        <>
          
            <video
                id="showvideoid"
                width="320"
                height="240"
                className="video"
                autoPlay>
            </video>

        </>
    )
}
export default Gaze